import React from 'react'
import { Link } from 'react-router-dom'

const ChatSectionHeader = ({ title, subtitle, backTo, actions }) => (
  <div className="d-flex flex-row justify-content-between align-items-start mb-3 gap-2">
    <div style={{ minWidth: 0 }}>
      <h1 className="mb-1 fs-4 fs-md-3 text-truncate">{title}</h1>
      {subtitle && <div className="text-muted small text-truncate">{subtitle}</div>}
    </div>
    <div className="d-flex gap-2 flex-wrap justify-content-end flex-shrink-0">
      {actions}
      {backTo && (
        <Link to={backTo} className="btn btn-secondary btn-sm">
          Назад
        </Link>
      )}
    </div>
  </div>
)

export default ChatSectionHeader
